function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, InputNumber, Flex, Tag, Space, Radio, Image, Alert, notification } from 'antd';
import { PlusCircleFill, EnvelopeAtFill, CashStack } from "react-bootstrap-icons";
import axios from 'axios';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var ChangePlan = function ChangePlan(_ref) {
  var handler = _ref.handler,
      businessAccount = _ref.businessAccount;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      pmList = _useState6[0],
      setPmList = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      pg = _useState8[0],
      setPg = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      unitPrice = _useState10[0],
      setUnitPrice = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      totalAmount = _useState12[0],
      setTotalAmount = _useState12[1];

  var _useState13 = useState(1),
      _useState14 = _slicedToArray(_useState13, 2),
      periode = _useState14[0],
      setPeriode = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      plans = _useState16[0],
      setPlans = _useState16[1];

  var _useState17 = useState(1),
      _useState18 = _slicedToArray(_useState17, 2),
      receptionMode = _useState18[0],
      setReceptionMode = _useState18[1];

  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append('subscription_plan_id', values.subscription_plan_id);
    formData.append('payment_gateway_id', values.payment_gateway_id);
    formData.append('businessAccount_id', businessAccount.id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'changesubscriptionplan', formData).then(function (response) {
      setIsFormLoading(false);

      if (response.data.code == 0) {
        console.log(JSON.stringify(response.data));
        window.location.href = response.data.payment_url;
      } else {
        setErrorMessage(response.data.error_message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };

  var handlePlanChange = function handlePlanChange(v) {
    if (plans.filter(function (p) {
      return p.value == v.target.value;
    })[0].price - businessAccount.subscription_plan.monthly_price > 0) setTotalAmount(plans.filter(function (p) {
      return p.value == v.target.value;
    })[0].price - businessAccount.subscription_plan.monthly_price);else {
      setTotalAmount(0);
    }
  };

  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + 'getpgs'), axios.get(Common.baseApiUrl + 'getsubscriptionplans/' + businessAccount.country_id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setPmList([]);
        response[0].data.pgs.forEach(function (pg) {
          setPmList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Flex, {
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  width: "210px",
                  src: "drawables/" + pg.logo
                }), /*#__PURE__*/_jsx("b", {
                  children: pg.label
                })]
              })
            }]);
          });
        });

        if (response[0].data.pgs.length > 0) {
          form.setFieldsValue({
            payment_gateway_id: response[0].data.pgs[0].id
          });
          setPg(response[0].data.pgs.filter(function (g) {
            return g.pdcode == 'CC';
          })[0]);
        }

        if (response[1].data.status == 200) {
          response[1].data.plans.forEach(function (e) {
            if (e.id != businessAccount.subscription_plan_id) {
              setPlans(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  price: e.monthly_price,
                  value: e.id,
                  label: /*#__PURE__*/_jsxs("div", {
                    style: {
                      width: "100%",
                      marginBottom: "5px",
                      borderRadius: "7px",
                      padding: "8px",
                      border: "1px solid #E1DCC5"
                    },
                    gap: "small",
                    justify: "center",
                    align: "center",
                    vertical: true,
                    children: [/*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx("div", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: e.label
                        })
                      }), /*#__PURE__*/_jsxs(Tag, {
                        color: "#40714A",
                        children: [e.monthly_price.toLocaleString("Fr"), " GNF / Mois"]
                      })]
                    }), /*#__PURE__*/_jsx("p", {
                      children: e.description
                    })]
                  })
                }]);
              });
            }
          });

          if (response[1].data.plans.filter(function (p) {
            return p.id != businessAccount.subscription_plan_id;
          }).length > 0) {
            setTotalAmount(response[1].data.plans.filter(function (p) {
              return p.id != businessAccount.subscription_plan_id;
            })[0].monthly_price - businessAccount.subscription_plan.monthly_price);
            form.setFieldsValue({
              subscription_plan_id: response[1].data.plans.filter(function (p) {
                return p.id != businessAccount.subscription_plan_id;
              })[0].id
            });
          }
        }
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue, verifiez votre connexion internet " + error.toString()
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          sm: 12,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            size: "large",
            label: "Choisir la formule souhait\xE9e",
            name: "subscription_plan_id",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              style: {
                width: "100%"
              },
              options: plans,
              onChange: handlePlanChange
            })
          })
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "payment_gateway_id",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          disabled: totalAmount <= 0,
          options: pmList
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(CashStack, {}),
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: totalAmount > 0 ? "Choisir et payer ".concat(totalAmount.toLocaleString('Fr')) : "Choisir"
          })
        })
      })]
    })
  });
};

export default ChangePlan;